import { Box, Grid, useTheme, useMediaQuery } from "@material-ui/core";
import { Quote } from "../../../api/Quote/Quote";
import { TF } from "../../../components/typography/TF";

const QuoteDetailsHeader = ({ quote, quoteName }: Props) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  if (quote === null) {
    return null;
  }

  return (
    <Grid container>
      <Grid item xs={12} md={7}>
        <TF ml={isSmall ? 2 : 6} variant="h5" bold paragraph>
          Quote Breakdown
        </TF>
      </Grid>
      <Grid item md={5} xs={12}>
        <Box
          ml={isSmall ? 2 : 0}
          mt={isSmall ? 2 : 0}
          display="flex"
          justifyContent={isSmall ? "flext-start" : "space-between"}
        >
          <Box ml={isSmall ? 0 : 12.6}>
            <TF component="span">Ref No:</TF>
            <TF bold component="span" ml={1}>
              {quoteName}
            </TF>
          </Box>
          <Box display="flex" mr={2.6}>
            <TF>Valid until:</TF>
            <TF bold format="timestamp" ml={1}>
              {quote.expiry || quote.created + 30 * 24 * 60 * 60 * 1000}
            </TF>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default QuoteDetailsHeader;

interface Props {
  quoteName: string;
  quote: Quote | null;
}
